// @ts-check
// Botões fixados no cabeçalho da lista (doc 15, seção 6.1): até dois comandos frequentes da lista, além de "+ Novo",
// gravados na view (`pinnedCommandKeys`). O motor valida a lista e a tela só mostra os que o papel permite.

/** Comandos da lista que podem virar botão no cabeçalho. */
export const PINNABLE_LIST_COMMAND_KEYS = Object.freeze(['import', 'export', 'createView', 'seeDeleted', 'filter', 'sort']);
export const MAXIMUM_PINNED_LIST_COMMANDS = 2;

/**
 * Lista válida de comandos fixados, sem repetidos, ou uma mensagem de erro.
 * @param {unknown} value
 * @returns {{ keys: string[], error: null } | { keys: null, error: string }}
 */
export function validatePinnedCommandKeys(value) {
  if (!Array.isArray(value)) return { keys: null, error: 'pinnedCommandKeys must be an array' };
  if (value.length > MAXIMUM_PINNED_LIST_COMMANDS) {
    return { keys: null, error: `pinnedCommandKeys accepts at most ${MAXIMUM_PINNED_LIST_COMMANDS} commands` };
  }
  for (const key of value) {
    if (typeof key !== 'string' || !PINNABLE_LIST_COMMAND_KEYS.includes(key)) {
      return { keys: null, error: `pinnedCommandKeys: '${String(key)}' is not pinnable. Allowed: ${PINNABLE_LIST_COMMAND_KEYS.join(', ')}` };
    }
  }
  return { keys: [...new Set(/** @type {string[]} */ (value))], error: null };
}

/**
 * Lê a coluna JSON; valor inválido (gravado à mão ou de versão futura) vira lista vazia em vez de quebrar a view.
 * @param {string | null | undefined} stored
 * @returns {string[]}
 */
export function readPinnedCommandKeys(stored) {
  if (!stored) return [];
  try {
    const parsed = JSON.parse(stored);
    const { keys } = validatePinnedCommandKeys(Array.isArray(parsed) ? parsed.filter((key) => PINNABLE_LIST_COMMAND_KEYS.includes(key)).slice(0, MAXIMUM_PINNED_LIST_COMMANDS) : []);
    return keys ?? [];
  } catch {
    return [];
  }
}

/**
 * Fixa ou desafixa um comando; o terceiro fixado tira o mais antigo, como uma fila de dois lugares.
 * @param {string[]} current @param {string} key
 * @returns {string[]}
 */
export function togglePinnedCommandKey(current, key) {
  if (current.includes(key)) return current.filter((candidate) => candidate !== key);
  return [...current, key].slice(-MAXIMUM_PINNED_LIST_COMMANDS);
}
